import { ConductorOneChildActive } from "@frui.ts/screens";
import type { ScreenBase } from "@frui.ts/screens";
import type { interfaces } from "inversify";
import { action, computed } from "mobx";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import { formatLicensePlate } from "utils/localizations";
import type ExemptionResponse from "entities/exemptionResponse";
import ExemptionDetailViewModel from "./exemptionDetailViewModel";
import ExemptionChangesViewModel from "./exemptionChangesViewModel";

export default class ExemptionDetailSectionViewModel extends ConductorOneChildActive<ScreenBase> {
  protected readonly exemptionDetailViewModel: ExemptionDetailViewModel;
  protected readonly exemptionChangesViewModel: ExemptionChangesViewModel;

  constructor(
    private exemption: ExemptionResponse,
    private localizationService: LocalizationService,
    exemptionDetailViewModelFactory: ReturnType<typeof ExemptionDetailViewModel.Factory>,
    exemptionChangesViewModelFactory: ReturnType<typeof ExemptionChangesViewModel.Factory>
  ) {
    super();
    this.exemptionDetailViewModel = exemptionDetailViewModelFactory(this.exemption.exemptionId);
    this.exemptionChangesViewModel = exemptionChangesViewModelFactory(this.exemption.exemptionId);
    this.children.push(this.exemptionDetailViewModel, this.exemptionChangesViewModel);
    this.navigationName = "";
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @computed
  get vehicleRegisterResponse() {
    return !!this.exemptionDetailViewModel.item?.vehicleRegisterVehicleDetail;
  }

  @computed
  get name() {
    return this.localizationService
      .translateModule(Modules.callCenter, "exemptionDetail.title")
      .replace("%licensePlate%", formatLicensePlate(this.exemption.vehicle));
  }

  @action.bound
  onClose() {
    this.requestClose();
  }

  static Factory({ container }: interfaces.Context) {
    return (exemptionResponse: ExemptionResponse) =>
      new ExemptionDetailSectionViewModel(
        exemptionResponse,
        container.get(LocalizationService),
        container.get(ExemptionDetailViewModel.Factory),
        container.get(ExemptionChangesViewModel.Factory)
      );
  }
}
